import React, { useState, useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';

const UserProfile = () => {
  const { instance, accounts } = useMsal();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (accounts.length > 0) {
      fetchUserInfo();
    }
  }, [accounts]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchUserInfo = async () => {
    try {
      const account = accounts[0];
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });

      const userResponse = await fetch('https://graph.microsoft.com/v1.0/me', {
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
        },
      });

      if (userResponse.ok) {
        const userData = await userResponse.json();
        setUserInfo(userData);
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setShowDropdown(false);
    instance.logoutPopup().catch(e => {
      console.error('Logout failed:', e);
    });
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  if (loading) {
    return null;
  }

  return (
    <div className="user-profile-compact" ref={dropdownRef}>
      <button 
        className="user-avatar-compact"
        onClick={toggleDropdown}
        title="User menu"
      >
        {userInfo?.displayName?.charAt(0) || accounts[0]?.name?.charAt(0) || '👤'}
      </button>
      
      {showDropdown && (
        <div className="user-dropdown">
          <div className="user-dropdown-header">
            <div className="user-dropdown-avatar">
              {userInfo?.displayName?.charAt(0) || accounts[0]?.name?.charAt(0) || '👤'}
            </div>
            <div className="user-dropdown-details">
              <div className="user-dropdown-name">
                {userInfo?.displayName || accounts[0]?.name || 'User'}
              </div>
              <div className="user-dropdown-email">
                {userInfo?.mail || userInfo?.userPrincipalName || accounts[0]?.username}
              </div>
            </div>
          </div>
          <div className="user-dropdown-actions">
            <button 
              className="btn-logout-dropdown" 
              onClick={handleLogout}
            >
              <svg viewBox="0 0 24 24" className="logout-icon">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
              </svg>
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfile;